import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PROVIDER_GET_ADDRESS_COVERAGE } from 'api/utilityActionTypes';

export default async function getAddressCoverageAction(
  { state, utilityApiClient },
  { addressId, refresh } = {},
) {
  typeCheck('addressId::PositiveNumber', addressId);
  typeCheck('refresh::Maybe Boolean', refresh);

  const statePath = ['utilityProviders', 'coverageByAddressId', addressId];
  if (!refresh && state.get(statePath)) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PROVIDER_GET_ADDRESS_COVERAGE,
    queryId: addressId,
    payload: {
      addressId,
    },
    state: state,
    onSuccess(utilityProviderAddressCoverage) {
      state.set(statePath, utilityProviderAddressCoverage);
    },
  });
}
